import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SimpleStickerCard from './SimpleStickerCard';
import CoreStickerCard from './CoreStickerCard';
import MaterialIcon from './MaterialIcon';
import logger from '../utils/logger.js';
import './AdminHomePage.css';

function AdminHomePage() {
  const [isAdminMode, setIsAdminMode] = useState(false);

  const handleAddToScene = (stickerData) => {
    logger.log('Add to scene:', stickerData);
    // TODO: Implement scene builder integration
  };

  return (
    <div className="admin-homepage">
      {/* Admin Header */}
      <header className="admin-header">
        <div className="admin-header-content">
          <h1>Clothed Eye Admin</h1>
          <p>Development and testing interface</p>
          <div className="admin-controls">
            <button
              onClick={() => setIsAdminMode(!isAdminMode)}
              className={`admin-mode-btn ${isAdminMode ? 'active' : ''}`}
            >
              <MaterialIcon icon="settings" size={16} />
              {isAdminMode ? 'Admin Mode ON' : 'Admin Mode OFF'}
            </button>
          </div>
        </div>
      </header>

      <main className="admin-homepage-main">
        <div className="container">
          {/* Hero Section */}
          <section className="hero-section">
            <div className="hero-content">
              <h2>Sticker Testing & Development</h2>
              <p>Compare SimpleStickerCard and CoreStickerCard implementations</p>
            </div>
          </section>

          {/* SimpleStickerCard Section */}
          <section className="stickers-grid-section">
            <h3>SimpleStickerCard (Public-Facing)</h3>
            <div className="stickers-grid">
              <SimpleStickerCard
                listingId="846621034"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <SimpleStickerCard
                listingId="1685177635"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <SimpleStickerCard
                listingId="978514071"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <SimpleStickerCard
                listingId="1206470499"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <SimpleStickerCard
                listingId="863310238"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
            </div>
          </section>

          {/* CoreStickerCard Section */}
          <section className="stickers-grid-section">
            <h3>CoreStickerCard (Admin/Full)</h3>
            <div className="stickers-grid">
              <CoreStickerCard
                listingId="846621034"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <CoreStickerCard
                listingId="1685177635"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <CoreStickerCard
                listingId="978514071"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <CoreStickerCard
                listingId="1206470499"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
              <CoreStickerCard
                listingId="863310238"
                onAdd={handleAddToScene}
                globalSize="MICRO"
                globalColor="Black"
                buttonText="BUY IT NOW"
                buttonIcon="add"
                isAdminMode={isAdminMode}
              />
            </div>
          </section>

          {/* Scene Builder Section */}
          <section className="scene-section">
            <h3>Scene Builder</h3>
            <p>Build your custom sticker scene</p>
            <div className="scene-builder-actions">
              <button className="scene-builder-btn">
                <MaterialIcon icon="add" size={20} />
                Open Scene Builder
              </button>
              <a href="/actual-size-test" className="test-page-link">
                <MaterialIcon icon="science" size={20} />
                ActualSizeSticker Test Page
              </a>
            </div>
          </section>

          {/* Admin Tools Section */}
          <section className="admin-tools-section">
            <h3>Admin Tools</h3>
            <p>Administrative and maintenance tools</p>
            <div className="admin-tools-actions">
              <a href="/listing-admin" className="admin-tool-link">
                <MaterialIcon icon="edit" size={20} />
                Listing Admin
              </a>
              <a href="/svg-path-auto-association" className="admin-tool-link">
                <MaterialIcon icon="auto_fix_high" size={20} />
                SVG Path Auto-Association
              </a>
              <a href="/color-audit" className="admin-tool-link">
                <MaterialIcon icon="palette" size={20} />
                Color Audit
              </a>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="admin-footer">
        <p>&copy; 2024 Clothed Eye. Admin Development Interface.</p>
      </footer>
    </div>
  );
}

// AdminHomePage has no props - it's a standalone admin page component
AdminHomePage.propTypes = {};

export default AdminHomePage;
